let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <ownerCode>货主编码 string (50), 必填</ownerCode>
    <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
    <processOrderCode>ERP加工单编码, string (50), 必填</processOrderCode>
    <orderType>单据类型, string (50), 例如: CNJG=仓内加工作业单</orderType>
    <orderCreateTime>加工单创建时间,  string (19), YYYY-MM-DD HH:MM:SS</orderCreateTime>
    <planTime>计划加工时间,  string (19), YYYY-MM-DD HH:MM:SS</planTime>
    <serviceType>加工类型, string (50), 1=组合加工 2=拆解加工, 必填</serviceType>
    <remark>备注, string (500)</remark>
    <recUnitCode>收货单位编码, string (500)</recUnitCode>
    <extendProps>扩展属性, string (500)</extendProps>
    <planQty>计划成品数量, float</planQty>
    <materialitems>
        <item>
            <itemCode>商品编码, string (50), 必填</itemCode>
            <itemId>仓储系统商品ID, string (50)</itemId>
            <quantity>数量, int, 必填</quantity>
            <inventoryType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</inventoryType>
            <virtualWarehouse>虚拟仓库, string (50)</virtualWarehouse>
            <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
            <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
            <batchCode>批次号, string (50)</batchCode>
            <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
            <userDefined1>自定义批次1, string (50)</userDefined1>
            <userDefined2>自定义批次2, string (50)</userDefined2>
            <userDefined3>自定义批次3, string (50)</userDefined3>
            <userDefined4>自定义批次4, string (50)</userDefined4>
            <remark>备注, string (500)</remark>
            <ratioQty>配比数量, string (500)</ratioQty>
        </item>
    </materialitems>
    <productitems>
        <item>
            <itemCode>商品编码, string (50), 必填</itemCode>
            <itemId>仓储系统商品ID, string (50)</itemId>
            <quantity>数量, int, 必填</quantity>
            <inventoryType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</inventoryType>
            <virtualWarehouse>虚拟仓库, string (50)</virtualWarehouse>
            <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
            <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
            <batchCode>批次号, string (50)</batchCode>
            <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
            <userDefined1>自定义批次1, string (50)</userDefined1>
            <userDefined2>自定义批次2, string (50)</userDefined2>
            <userDefined3>自定义批次3, string (50)</userDefined3>
            <userDefined4>自定义批次4, string (50)</userDefined4>
            <remark>备注, string (500)</remark>
            <ratioQty>配比数量, string (500)</ratioQty>
        </item>
    </productitems>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

export default { xmlRequest, xmlResponse }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.storeprocess.create.js